import {postsText} from './postsText';

export const postPosterText = {
  heading: postsText.postPosterHeading,
  replace: postsText.posterReplace,
  remove: postsText.posterRemove,
  emptyTitle: postsText.posterEmptyTitle,
  emptyHint: postsText.posterEmptyHint,
  hint: postsText.posterHint,
  hintEmpty: postsText.posterEmptyStateHint,
};
